import React from "react";
import ParindayHero from "../components/Parinday/hero";
import PCta from "../components/Parinday/cta";
import ParindayMarquee from "../components/Parinday/parinday-marquee";
import PVideo from "../components/Parinday/videos";
import Pplus from "../components/Parinday/plus";
import PCards from "../components/Parinday/cards";

export default function VittVichaar() {
  return (
    <>
      <div className="py-12 px-8">
        <ParindayHero />
      </div>
      <ParindayMarquee />
      <Pplus />
      <PVideo />
      <PCards />
      <PCta />
    </>
  );
}
